/**
 * Strips hidden context markers from a message.
 * Hidden context is marked with {{context:...}} and is sent to the AI
 * but not displayed to the user for a cleaner UX.
 *
 * This allows us to provide additional context to the AI (like product URLs)
 * without cluttering the user's message display.
 *
 * Examples:
 * - Input: "I'm interested in Botox {{context:/pdp/package/123}}"
 *   Output: "I'm interested in Botox"
 *
 * - Input: "Tell me more {{context:/pdp/package/abc}} about this product"
 *   Output: "Tell me more about this product"
 *
 * @param message - The message string that may contain hidden context
 * @returns The message with hidden context removed and trimmed
 */
export function stripHiddenContext(message: string): string {
  // Remove all {{context:...}} patterns, including any whitespace before them
  return message.replace(/\s*\{\{context:[^}]*\}\}/g, "").trim();
}
